// extracted by mini-css-extract-plugin
export default {"videos":"Videos_videos__M-FNn"};